export default __webpack_public_path__ + "static/media/blog_5.84eeee21.png";